<template>
	<div class="wrap">
		<myHead></myHead>
		<div class="wrap_body">
			<div class="center">
				<div class="ucenter_main">
					<ucMenu num="4"></ucMenu>
					<div class="right_con">
						<div class="wallet_main">
							<div class="ye_wrap">
								<p class="fb">我的可用余额</p>
								<p class="balance"><em>{{wallet_money_d}}</em>.{{wallet_money_x}}</p>
								<!-- <p class="price_txt">
									<span>已解冻</span>：<em>{{wallet_already_thaw}}</em><i class="iconfont icon-shuoming" @click="$router.push('./notice?type=2&id=1')"></i>
									<span style="margin-left: 20px;">冻结金额</span>：<em>{{wallet_stay_thaw}}</em><i class="iconfont icon-shuoming" @click="$router.push('./notice?type=2&id=1')"></i> -->
								</p>
							</div>
							<!-- <p class="tx_btn" @click.self="is_tixian = true">提现</p> -->
							<p class="tx_btn" @click.self="is_chongzhi = true">充值</p>
						</div>
						<div class="record_main">
							<p class="fb">交易记录</p>
							<div class="screen_wrap">
								<div class="left_tabs">
									<p class="tab" :class="recordType==''?'active':''" @click="changeType('')"><span>全部</span></p>
									<p class="tab" :class="recordType==4?'active':''" @click="changeType('4')"><span>提现</span></p>
									<p class="tab" :class="recordType==31?'active':''" @click="changeType('31')"><span>采购</span></p>
									<p class="tab" :class="recordType==32?'active':''" @click="changeType('32')"><span>服务费</span></p>
									<!-- <p class="tab" :class="recordType==5?'active':''" @click="changeType('5')"><span>成交</span></p>
									<p class="tab" :class="recordType==3?'active':''" @click="changeType('3')"><span>退款</span></p> -->
									<!-- <p class="tab" :class="recordType==8?'active':''" @click="changeType('8')"><span>解冻金额</span></p> -->
									<!-- <p class="tab" :class="recordType==9?'active':''" @click="changeType('9')"><span>奖励金</span></p> -->
									<p class="tab" :class="recordType==10?'active':''" @click="changeType('10')"><span>其他</span></p>
								</div>
								<div class="right_time">
									<p class="txt">日期：</p>
									<el-date-picker
									      v-model="rangeTime"
									      type="datetimerange"
									      range-separator="-"
									      start-placeholder="开始日期"
									      end-placeholder="结束日期"
									      :clearable="false"
									      format="yyyy-MM-dd HH:mm">
									</el-date-picker>
									<el-button plain size="medium" @click="timeCheck()">查询</el-button>
								</div>
							</div>
							<div class="table_wrap">
								<el-table :data="tableData" style="width: 100%">
									<el-table-column prop="createtime" label="交易时间" width="200">
									</el-table-column>
									<!-- <el-table-column prop="order_no" label="订单编号">
									</el-table-column> -->
									<el-table-column prop="typename" label="类型">
									</el-table-column>
									<el-table-column prop="scope" label="金额（元）">
										<template slot-scope="scope">
											<span :style="scope.row.money>0?'':'color: var(--red);'">{{scope.row.money}}</span>
										</template>
									</el-table-column>
									<el-table-column prop="after_money" label="余额">
										<template slot-scope="scope">
											{{scope.row.after_money>0?scope.row.after_money:'-'}}
										</template>
									</el-table-column>
									<el-table-column prop="msg" label="说明" width="180">
									</el-table-column>
									<el-table-column prop="order_no" label="订单号" width="180" v-if="recordType==31||recordType==32"></el-table-column>
								</el-table>
							</div>
							<div class="turn_page">
								<el-pagination
								      :page-size="page_size"
								      layout="total,prev, pager, next, jumper"
								      prev-text="上一页"
								      next-text="下一页"
								      :total="listTotal"
								      hide-on-single-page
								      :current-page="page"
								      @current-change="currentChange">
								</el-pagination>
							</div>
						</div>
					</div>
				</div>
				<div :class="is_tixian?'tixian_mask active' : 'tixian_mask'" @click.self="is_tixian = false">
					<div class="tixian_main">
						<i class="iconfont icon-guanbi" @click.self="is_tixian = false"></i>
						<p class="title"><i class="iconfont icon-qian"></i>余额提现<span class="t">（可提现金额 <em>￥{{tixian_able}}</em>）</span></p>
						<div class="tx_count">
							<input v-model="input_tixian" class="in" placeholder="输入提现金额" />
							<p class="tx" @click="input_tixian = tixian_able">全部提现</p>
						</div>
						<p class="title_txt">提现到</p>
						<div class="tx_tabs">
							<div class="tab" :class="tixianType==2?'active':''" @click="changeTXWay('2')"><img src="../../assets/images/bankcard.png" /></div>
							<div class="tab" :class="tixianType==1?'active':''" @click="changeTXWay('1')"><img src="../../assets/images/alipay.png" /></div>
						</div>
						<p class="title_txt">选择账户</p>
						<div class="tx_sel_main" v-if="tixianList.length>0">
							<div class="tx_sel auto_scrollbar" v-if="tixianType==2">
								<div class="sel_tab" :class="item.xuanze?'active':''" v-for="(item,index) in tixianList" :key="index" @click="bankOpt_set(index)">
									<p>开户行：<span>{{item.kaihu_name}}</span></p>
									<p>卡号：<span>{{item.zfbMember}}</span></p>
									<p>用户名：<span>{{item.zfbName}}</span></p>
								</div>
							</div>
							<div class="tx_sel auto_scrollbar" v-else-if="tixianType==1">
								<div class="sel_tab" :class="item.xuanze?'active':''" v-for="(item,index) in tixianList" :key="index" @click="zfbOpt_set(index)">
									<p>支付宝账号：<span>{{item.zfbMember}}</span></p>
									<p>用户名：<span>{{item.zfbName}}</span></p>
								</div>
							</div>
						</div>
						<div class="nodata" v-else>暂无账户</div>
						<div class="btn_wrap">
							<p class="btn" @click.self="is_tixian = false">取消</p>
							<p class="btn" @click="bindTixian()">确定</p>
						</div>
					</div>
				</div>
				<el-dialog class="chongzhi_mask" :visible.sync="is_chongzhi" width="450px" @close="hideChongZhi" :close-on-press-escape="false" :close-on-click-modal="false">
					<div class="chongzhi_main">
						<p class="title"><img class="icon" src="@/assets/images/zhifubao.png" />支付宝扫码充值</p>
						<div class="input_line">
							<p class="txt">充值金额：</p>
							<el-input class="in" placeholder="输入充值金额" v-model="recharge_money"></el-input>
						</div>
						<img class="code" v-if="paymentCodeImg" :src="paymentCodeImg" />
						<div class="tips" v-if="recharge_tips">{{recharge_tips}}</div>
						<div class="btn_wrap" v-if="!paymentCodeImg">
							<!-- <p class="btn" @click.self="is_chongzhi = false">取消</p> -->
							<p class="btn" @click="bindGetPayCode()" >充值</p>
						</div>
					</div>
				</el-dialog>
			</div>
		</div>
		<myFoot></myFoot>
	</div>
</template>

<script>
import Vue from 'vue';
import { mapActions,mapState,mapMutations } from "vuex";
import myHead from '../../components/myHead/myhead';
import myFoot from '../../components/myFoot/myfoot';
import ucMenu from '../../components/ucenterMenu/ucmenu';
export default {
	name: "ucenterWallet",
	data() {
		return {
			input1:"",
			input2:"",
			value1:"",
			rangeTime:"",
			startTime:"",
			endTime:"",
			is_chongzhi:false,
			is_tixian:false,
			tableData: [],
			wallet_money_d:"0",
			wallet_money_x:"00",
			wallet_already_thaw:"0.00",
			wallet_stay_thaw:"0.00",
			tixianType:"2",
			tixian_able:"0.00",
			input_tixian:"",
			tixianList:[],
			is_doTixian:false,
			recordType:"",
			page:1,
			page_size:10,
			listTotal:0,

			paymentCodeImg:"",
			paymentNum:"",
			recharge_money: '',
			recharge_tips: '',
			order_no: ''
		}
	},
	components:{
		myHead,myFoot,ucMenu
	},
	computed:{
		...mapState({

		}),
	},
	created(){
		this.getWalletInfo()
		this.getRecordData()
	},
	methods: {
		...mapActions({
			getMoneyData:"ucenter/getMoneyData",
			getTixianInfo:"ucenter/getTixianInfo",
			getPaymentCode:"ucenter/getPaymentCode",
			getMywalletCheckPayState:"ucenter/getMywalletCheckPayState",
			doTixian:"ucenter/doTixian",
			getWallteData:"ucenter/getWallteData",
			doBankSet:"ucenter/doBankSet",
			doZfbSet:"ucenter/doZfbSet",
			doTixian:"ucenter/doTixian",
		}),
		getWalletInfo(){//获取钱包数据
			this.getMoneyData({data:{},success:(res)=>{
				if(res.code===200){
					console.log('get money data',res)
					this.wallet_money_d = parseInt(res.data.money)
					this.wallet_money_x = res.data.money.slice(-2)
					this.wallet_already_thaw = res.data.already_thaw
					this.wallet_stay_thaw = res.data.stay_thaw
					this.getTXInfo()
				} else {
					this.$message({message: res.msg,type: 'error',});
				}
			}})
		},
		getTXInfo(){//获取提现相关数据
			this.getTixianInfo({data:{
					type:this.tixianType,
				},success:(res)=>{
				if(res.code===200){
					console.log('get tixian info',res)
					this.tixian_able = res.data.money
					this.tixianList = res.data.lists
				} else {
					this.$message({message: res.msg,type: 'error',});
				}
			}})
		},
		changeTXWay(type){//切换提现方法（银行卡/支付宝）
			this.tixianType = type
			this.getTXInfo()
		},
		zfbOpt_set(i){//设置默认支付宝账户
			this.doZfbSet({data:{
					id:this.tixianList[i].id,
				},success:(res)=>{
				if(res.code===200){
					console.log('set default zfb success',res)
					this.getTXInfo()
				} else {
					this.$message({message: res.msg,type: 'error',});
				}
			}})
		},
		bankOpt_set(i){//设置默认银行卡账户
			this.doBankSet({data:{
					id:this.tixianList[i].id,
				},success:(res)=>{
				if(res.code===200){
					console.log('set default bank success',res)
					this.getTXInfo()
				} else {
					this.$message({message: res.msg,type: 'error',});
				}
			}})
		},
		bindTixian(){//发起提现
			let id = ''
			if(!this.input_tixian){
				this.$message({message: '请输入提现金额',type: 'error',});
				return false
			}
			if(this.tixianList.length>0){
				for(let i in this.tixianList){
					if(this.tixianList[i].xuanze){
						id = this.tixianList[i].id
						break
					}
				}
			}else{
				this.$message({message: '请前往个人设置添加提现账户',type: 'error',});
				return false
			}
			if(!this.is_doTixian){
				this.is_doTixian = true
				this.doTixian({data:{
						id:id,
						money:this.input_tixian
					},success:(res)=>{
					if(res.code===200){
						console.log('do tixian',res)
						this.$message({message: res.msg,type: 'success',});
						setTimeout(()=>{
							this.is_tixian = false
							this.is_doTixian = false
							this.input_tixian = ""
							this.getWalletInfo()
						},500)
					} else {
						this.$message({message: res.msg,type: 'error',});
						this.is_doTixian = false
					}
				}})
			}
		},
		getRecordData(){//获取钱包记录流水
			this.getWallteData({data:{
				type:this.recordType,
				page:this.page,
				pagesize:this.page_size,
				start_time:this.startTime,
				end_time:this.endTime
			},success:(res)=>{
				if(res.code===200){
					console.log('get wallet record list',res)
					this.tableData = res.data.data
					this.listTotal = res.data.total
				} else {
					this.$message({message: res.msg,type: 'error',});
				}
			}})
		},
		timeCheck(){//日期查询
			this.startTime = this.rangeTime?this.DateToStr(this.rangeTime[0]):''
			this.endTime = this.rangeTime?this.DateToStr(this.rangeTime[1]):''
			this.getRecordData()
		},
		DateToStr(date){
			let year = date.getFullYear();//年
			let month = date.getMonth();//月
			let day = date.getDate();//日
			let hours = date.getHours();//时
			let min = date.getMinutes();//分
			let second = date.getSeconds();//秒
			return year + "-" +
				((month + 1) > 9 ? (month + 1) : "0" + (month + 1)) + "-" +
				(day > 9 ? day : ("0" + day)) + " " +
				(hours > 9 ? hours : ("0" + hours)) + ":" +
				(min > 9 ? min : ("0" + min)) + ":" +
				(second > 9 ? second : ("0" + second));
		},
		changeType(val){
			this.recordType = val
			this.page = 1
			this.getRecordData()
		},
		currentChange(val){
			this.page = val
			this.getRecordData()
			console.log(val)
		},


		bindGetPayCode(){
			if(this.recharge_money <= 0){
				this.$message({message: '请输入充值金额',type: 'info',});
				return
			}
			this.getPaymentCode({data:{money:this.recharge_money},success:(res)=>{
				if(res.code===200){
					console.log('get payment code',res)
					this.paymentCodeImg = res.data.qr_code_url
					this.recharge_tips = res.data.tips
					this.order_no = res.data.order_no
					this.checkPayState()
				} else {
					this.$message({message: res.msg,type: 'error',});
				}
			},error:(res)=>{
				console.log(333)
			}})
		},
		checkPayState(){
			let that = this
			if(!this.is_chongzhi||!this.order_no){
				return
			}
			this.getMywalletCheckPayState({data:{order_no:this.order_no},success:(res)=>{
				if(res.code===200){
					console.log('get check state',res)
					if(res.data == 1){
						this.$message({message: '充值成功',type: 'success',});
						this.order_no = ''
						this.recharge_tips = ''
						this.paymentCodeImg = ''
						this.recharge_money = ''
						this.is_chongzhi = false
						this.getWalletInfo()
						this.getRecordData()

					}else{
						setTimeout(function(){
							that.checkPayState()
						},2000)
					}
				} else {
					this.$message({message: res.msg,type: 'error',});
				}
			}})
		},
		hideChongZhi(){
			this.is_chongzhi=false
			this.paymentCodeImg = ''
			this.recharge_money = ''
			this.order_no = ''
			this.recharge_tips = ''
		},
		bindRecharge(){//充值查询
			if(!this.paymentNum){
				this.$message({message: '请输入支付订单编号',type: 'error',});
				return false
			}
			if(!this.is_payment){
				this.is_payment = true
				this.getMywalletCheckPayState({data:{
					trade_no:this.paymentNum
				},success:(res)=>{
					if(res.code===200){
						console.log('get payment code',res)
						this.$message({message: res.msg,type: 'success',});
						setTimeout(()=>{
							this.is_payment = false
							this.paymentNum = ""
							this.is_chongzhi = false
							this.getWalletInfo()
							this.getRecordData()
						},500)
					} else {
						this.is_payment = false
						this.$message({message: res.msg,type: 'error',});
					}
				}})
			}
		},

	}
}
</script>

<style scoped>
.wrap .wrap_body{display: flex;flex-direction: column;}
.center{display: flex;flex: 1;}
.ucenter_main{padding: 30px 0 40px;display: flex;justify-content: space-between;flex: 1;}
.right_con{width: 980px;}
.wallet_main{padding: 0 70px 58px;background: #fff;display: flex;}
.wallet_main .ye_wrap{margin-top: 36px;}
.wallet_main .ye_wrap .balance{margin-top: 30px;font-weight: bold;font-size: 30px;}
.wallet_main .ye_wrap .balance>em{font-size: 50px;}
.wallet_main .ye_wrap .price_txt{margin-top: 30px;font-size: 14px;display: flex;align-items: center;}
.wallet_main .ye_wrap .price_txt>em{font-weight: bold;}
.wallet_main .ye_wrap .price_txt .icon-shuoming{font-size: 16px;color: #558ed5;margin-left: 8px;cursor: pointer;}
.wallet_main .tx_btn{width: 115px;height: 40px;border-radius: 6px;display: flex;justify-content: center;align-items: center;font-size: 14px;font-weight: bold;box-sizing: border-box;cursor: pointer;background: #f0413e;color: #fff;margin: 80px 0 0 130px;}
.record_main{margin-top: 16px;padding: 30px 40px 40px;background: #fff;line-height: 1;}
.record_main .screen_wrap{margin-top: 12px;height: 50px;border-bottom: 1px solid #eee;display: flex;justify-content: space-between;}
.screen_wrap .left_tabs{display: flex;height: 100%;}
.screen_wrap .left_tabs .tab{height: 100%;position: relative;cursor: pointer;display: flex;align-items: center;}
.screen_wrap .left_tabs .tab>span{padding: 0 16px;border-right: 1px solid #eee;font-size: 14px;color: #333333;white-space: nowrap;}
.screen_wrap .left_tabs .tab.active::after{content: '';width: 100%;height: 3px;background: var(--red);position: absolute;left: 0;bottom: 0;z-index: 2;}
.screen_wrap .left_tabs .tab.active>span{color: var(--red);font-weight: bold;}
.screen_wrap .left_tabs .tab:last-child>span{border-right: none;}
.screen_wrap .right_time{display: flex;justify-content: flex-end;align-items: center;}
.screen_wrap .right_time .txt{font-size: 14px;color: #666666;margin-left: 10px;display: flex;justify-content: center;align-items: center;}
.turn_page{display: flex;justify-content: flex-end;margin-top: 30px;}

.tixian_mask{width: 100%;height: 100%;position: fixed;top: 0;left: 0;background: rgba(0, 0, 0, .5);z-index: 999;transition: all .5s;visibility: hidden;opacity: 0;}
.tixian_mask.active{visibility: visible;opacity: 1;}
.tixian_mask .tixian_main{width: 400px;height: 550px;box-sizing: border-box;padding: 36px 0 40px;background: #fff;position: absolute;top: 50%;left: 50%;transform: translate(-50%,-70%);visibility: hidden;opacity: 0;transition: all .5s;display: flex;flex-direction: column;}
.tixian_mask.active .tixian_main{transform: translate(-50%,-50%);visibility: visible;opacity: 1;}
.tixian_main .icon-guanbi{font-size: 12px;color: #999;position: absolute;top: 16px;right: 16px;cursor: pointer;z-index: 222;}
.tixian_main .title{margin: 0 22px;font-size: 20px;line-height: 1;}
.tixian_main .title .icon-qian{margin-right: 8px;font-size: 24px;color: #f38f00;}
.tixian_main .title .t{font-size: 12px;color: #666666;}
.tixian_main .title .t>em{color: var(--red);}
.tixian_main .title_txt{margin: 16px 32px 0;line-height: 1;font-size: 14px;}
.tixian_main .tx_count{margin: 24px 32px 0;height: 80px;background: #f5f5f5;border-radius: 4px;box-sizing: border-box;padding: 0 18px;display: flex;align-items: center;}
.tixian_main .tx_count .in{font-size: 30px;color: #333;font-weight: bold;flex: 1;width: 0;}
.tixian_main .tx_count .in::placeholder{font-size: 16px;color: #cccccc;line-height: 34px;}
.tixian_main .tx_count .tx{font-size: 12px;color: #f0413e;margin-left: 18px;cursor: pointer;}
.tixian_main .tx_tabs{margin: 12px 32px 0;display: flex;}
.tixian_main .tx_tabs .tab{width: 150px;height: 46px;border-radius: 4px;border: 1px solid #dddddd;background: #fff;display: flex;justify-content: center;align-items: center;margin-right: 10px;cursor: pointer;box-sizing: border-box;}
.tixian_main .tx_tabs .tab img{width: auto;height: 24px;}
.tixian_main .tx_sel_main{flex: 1;height: 0;display: flex;flex-direction: column;}
.tixian_main .tx_sel{margin: 12px 32px 0;flex: 1;height: 0;overflow-x: hidden;overflow-y: auto;padding: 0 4px;}
.tixian_main .tx_sel .sel_tab{width: 100%;height: auto;border-radius: 4px;border: 1px solid #dddddd;background: #fff;box-sizing: border-box;overflow: hidden;position: relative;margin-top: 8px;padding: 4px 16px;display: flex;flex-direction: column;justify-content: center;font-size: 12px;line-height: 20px;color: #666666;cursor: pointer;}
.tixian_main .tx_sel .sel_tab:first-child{margin-top: 0;}
.tixian_main .tx_sel .sel_tab span{color: #333;}
.tixian_main .tx_sel .sel_tab::before{content: '\e605';font-size: 22px;color: #dddddd;position: absolute;top: 0;right: -1px;z-index: 2;font-family: "iconfont" !important;}
.tixian_main .tx_tabs .tab:hover ,.tixian_main .tx_sel .sel_tab:hover{background: #f9f9f9;}
.tixian_main .tx_tabs .tab.active ,.tixian_main .tx_sel .sel_tab.active{border-color: #f49492;background: #fff;}
.tixian_main .tx_sel .sel_tab.active::before{color: #f0413e;}
.tixian_main .nodata{flex: 1;height: 0;display: flex;justify-content: center;align-items: center;font-size: 12px;color: #666666;}
.tixian_main .btn_wrap{margin: 30px 32px 0;display: flex;justify-content: space-between;}
.tixian_main .btn_wrap .btn{width: 160px;height: 40px;box-sizing: border-box;border-radius: 6px;display: flex;justify-content: center;align-items: center;font-size: 14px;cursor: pointer;}
.tixian_main .btn_wrap .btn:nth-child(1){border: 1px solid #dddddd;color: #333;}
.tixian_main .btn_wrap .btn:nth-child(2){background: #f0413e;color: #fff;}

</style>
<style>
.chongzhi_main{box-sizing: border-box;background: #fff;}
.chongzhi_main .icon-guanbi{font-size: 12px;color: #999;position: absolute;top: 16px;right: 16px;cursor: pointer;z-index: 222;}
.chongzhi_main .title{display: flex;align-items: center;margin: 0 22px;font-size: 20px;line-height: 1;}
.chongzhi_main .title .icon{width: 22px;height: 22px;margin-right: 8px;}
.chongzhi_main .input_line{margin: 15px 22px 0;display: flex;align-items: center;}
.chongzhi_main .input_line .txt{font-size: 12px;color: #666666;margin-right: 10px;}
.chongzhi_main .input_line .in{width: auto;}
.chongzhi_main .code{width: 155px;height: auto;display: block;margin: 30px auto 0;}
.chongzhi_main .tips{margin-top: 10px;text-align: center;}
.chongzhi_main .btn_wrap{margin: 45px 0 0;display: flex;justify-content: space-around;}
.chongzhi_main .btn_wrap .btn{width: 160px;height: 40px;box-sizing: border-box;border-radius: 6px;display: flex;justify-content: center;align-items: center;font-size: 14px;cursor: pointer;}
.chongzhi_main .btn_wrap .btn:nth-child(2){border: 1px solid #dddddd;color: #333;}
.chongzhi_main .btn_wrap .btn:nth-child(1){background: #f0413e;color: #fff;}
.el_input{display: flex;margin: 14px 32px 0;width: initial;}
.el_input .el-input__inner{height: 38px;line-height: 38px;padding-left: 58px;flex: 1;width: 0;}
.el_input .el-input__inner:focus{border-color: var(--red);}
.el_input.el_in2 .el-input__inner{padding-left: 100px;}
.el_input .el-input__prefix{left: 2px;top: 1px}
.el_input .el-input__prefix .icons{width: 38px;height: 36px;display: flex;justify-content: center;align-items: center;top: 1px;left: 2px;background: #f5f5f5;border-right: 1px solid #ddd;border-radius: 4px 0 0 4px;}
.el_input .el-input__prefix .icons .iconfont{font-size: 20px;color: #cccccc;}
.el_input .el-input__prefix .txts{width: 100%;height: 100%;display: flex;align-items: center;padding-left: 10px;}
.el_input .el-input__suffix{display: flex;}
.el_input .el-input__suffix .el-input__suffix-inner{display: flex;align-items: center;}
.el_input .el-input__suffix .el-input__suffix-inner .getcode{font-size: 14px;color: #333333;padding: 0 12px;border-left: 1px solid #ccc;line-height: 1;cursor: pointer;}

.screen_wrap .right_time .el-input__inner{height: 36px;line-height: 36px;font-size: 12px;padding: 0 8px;border-radius: 4px;width: auto;margin-right: 14px;}
.screen_wrap .right_time .el-date-editor .el-range__icon{color: #666;line-height: 36px;}
.screen_wrap .right_time .el-range-editor .el-range-input{width: 120px;line-height: 36px;color: #333;}
.screen_wrap .right_time .el-date-editor .el-range-separator{color: #666;line-height: 36px;font-size: 12px;}
.screen_wrap .right_time .el-date-editor .el-range__close-icon{line-height: 36px;display: none;}
.el-button--text{padding: 7px 15px !important;}
.el-button--text:hover{border-color: var(--red);color: var(--red);}
.el-table .el-table__cell{text-align: center;padding: 14px 0;}
.el-table thead .el-table__cell{padding: 3px 0;background: #f9f9f9;color: #666;border-bottom: none !important;}

.el-button{color: #333;border-color: #ddd;}
.el-button--small{padding: 7px 15px;}
.el-checkbox{color: #666;display: flex;align-items: center;}
.el-checkbox__inner{border-color: #ddd;width: 16px;height: 16px;}
.el-checkbox__input{display: flex;}
.el-checkbox__label{font-size: 12px;line-height: 1;}
.el-checkbox__inner::after{height: 9px;left: 5px;}
.el-checkbox__input.is-indeterminate .el-checkbox__inner::before{height: 4px;}

/*red border color*/
.el-button.is-plain:focus, .el-button.is-plain:hover ,.el-checkbox__inner:hover ,.el-checkbox__input.is-focus .el-checkbox__inner,.el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner, .el-pagination__jump .el-input__inner:focus ,.el-input__inner:focus ,.el-range-editor.is-active, .el-range-editor.is-active:hover{border-color: var(--red);}

/*red color*/
.el-button.is-plain:focus, .el-button.is-plain:hover, .el-checkbox__input.is-checked+.el-checkbox__label, .el-pager li.active ,.el-pagination button:hover ,.el-pager li:hover ,.el-date-table td.today span ,.el-date-table td.available:hover ,.el-time-panel__btn.confirm{color: var(--red);}

/*red background color*/
.el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner ,.el-date-table td.end-date span, .el-date-table td.start-date span{background-color: var(--red);}
</style>
